function onVideoPause( video, playButton ) {
    video.removeAttribute( 'controls' );
    playButton.classList.remove( 'video-play-button--hidden' );
}

function onVideoPlay( video, playButton ) {
    video.play();
    video.setAttribute( 'controls', 'controls' );
    playButton.classList.add( 'video-play-button--hidden' );
}

function onVideoSeeking( video ) {
    video.setAttribute( 'controls', 'controls' );
}

document.querySelectorAll( '.wp-block-media-text video' )?.forEach( ( video ) => {
    const playButton = video.nextElementSibling;

    if ( playButton ) {
        playButton.addEventListener( 'click', () => { video.paused ? video.play() : video.pause() } );
        video.addEventListener( 'pause', () => onVideoPause( video, playButton ) );
        video.addEventListener( 'seeking', () => onVideoPlay( video, playButton ) );
        video.addEventListener( 'play', () => onVideoPlay( video, playButton ) );
    }
} );
